import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/login");
      return;
    }
    const sessionId = m[1];
    (async () => {
      try {
        const { data } = await api.post(
          "/auth/google/session",
          {},
          { headers: { "X-Session-ID": sessionId } }
        );
        // Also save session_token as bearer for axios fallback
        if (data.session_token) localStorage.setItem("hb_token", data.session_token);
        setUser(data.user);
        // Clean URL fragment
        window.history.replaceState({}, "", "/account");
        navigate("/account", { state: { user: data.user } });
      } catch {
        navigate("/login");
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="py-32 text-center text-[#5C4A4D]" data-testid="auth-callback">
      <p className="font-serif-display text-3xl text-[#1A0F11]">Signing you in...</p>
    </div>
  );
}
